import { defaultMotifs, findMotifs } from './motifs.mjs'

const copy = (value) => JSON.parse(JSON.stringify(value))
const isExample = (motif) =>
  motif &&
  (motif.id === 'example' ||
    motif.mode === 'example' ||
    [motif.name, motif.english].some((name) => /^(example support|例证支撑)$/i.test(name || '')))
const divergent = () => copy(defaultMotifs.find((motif) => motif.id === 'divergent'))

function cleanList(list) {
  if (!Array.isArray(list)) return list
  const result = []
  for (const motif of list) {
    const next = isExample(motif)
      ? divergent()
      : motif.id === 'divergent'
        ? {
            ...motif,
            english: 'Divergent support',
            name: motif.name === 'Divergent argument' ? 'Divergent support' : motif.name,
          }
        : motif
    if (next.id !== 'divergent' || !result.some((item) => item.id === 'divergent')) result.push(next)
  }
  return result
}

// Migrate only Example support and its analysis. Never relabel the old matches:
// divergent topology must be matched again against the existing annotated graph.
export function migrateExampleSupport(input) {
  const bundle = copy(input)
  const visit = (value) => {
    if (!value || typeof value !== 'object') return
    const oldMotifs = value.motifs || []
    const oldByDocument = { ...value.motifsByDocument }
    value.motifs = cleanList(value.motifs)
    if (value.motifs === undefined) delete value.motifs
    for (const [id, motifs] of Object.entries(value.motifsByDocument || {}))
      value.motifsByDocument[id] = cleanList(motifs)
    const cleanDocument = (doc, motifs = oldMotifs) => {
      const analysis = doc?.motifAnalysis
      if (!analysis) return
      const ids = new Set(['example', ...motifs.filter(isExample).map((motif) => motif.id)])
      for (const [id, definition] of Object.entries(analysis.definitions || {}))
        if (isExample(definition)) ids.add(id)
      const found =
        Object.keys(analysis.definitions || {}).some((id) => ids.has(id)) ||
        Object.keys(analysis.hashes || {}).some((id) => ids.has(id)) ||
        (analysis.results || []).some((result) => ids.has(result.id))
      for (const field of ['definitions', 'hashes'])
        for (const id of ids) if (analysis[field]) delete analysis[field][id]
      if (found) {
        const motif = divergent()
        const matches = findMotifs(doc, motif, 250, value.schemas, value.links)
        analysis.results = (analysis.results || []).filter(
          (result) => !ids.has(result.id) && result.id !== 'divergent',
        )
        analysis.results.push({
          id: 'divergent',
          count: matches.length,
          truncated: matches.length >= 250,
          matches,
        })
        analysis.definitions ||= {}
        analysis.definitions.divergent = motif
        if (analysis.hashes) delete analysis.hashes.divergent
      } else if (analysis.definitions?.divergent) {
        analysis.definitions.divergent = cleanList([analysis.definitions.divergent])[0]
      }
    }
    cleanDocument(value.document)
    for (const [id, doc] of Object.entries(value.documents || {}))
      cleanDocument(doc, oldByDocument[id] || oldMotifs)
    for (const draft of Object.values(value.drafts || {})) {
      visit(draft.bundle)
      visit(draft.base)
    }
  }
  visit(bundle)
  return bundle
}
